/* eslint-disable no-unused-vars */
import GlobalStore from "@ipru-common/store/GlobalStore";
import { convertToDateTime, convertToISODate, getMultiplier, readQueryParams } from "../CommonFunctions";
import { OPTION_VALUES, PaymentOptionName } from "@ipru-common/constants/InputValues";

import { mapDataToSuitabilityData } from "@ipru-common/components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";
import { getWOPOption, yesNo } from "../SavingsAppForm/SavingAppFormsUtils";
import { getCiTerm } from "../QuoteCommonFunctions";
import { getCurrentTimeStamp } from "../SavingsAppForm/SavingAppFormsUtils";
import _ from "lodash";

const getGppFlexiNetCoreInput = () => {
  const { appFormData, quoteFormData, calculatorFormData, savingForm, existingCustomer, currentPageStep } =
    GlobalStore.getSnapshot();

  const suitabilityData = mapDataToSuitabilityData(calculatorFormData, quoteFormData);
  const queryParams = readQueryParams();
  const { isWopSelected } = getWOPOption(quoteFormData?.selectedRiders);
  !!quoteFormData?.selectedRiders?.length > 0 ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING;
  const UID = queryParams.get("UID") || "480";
  const death_benefit =
    Number(quoteFormData?.selectedAnnuityOption?.result?.PremiumSummary?.AnnualPremium) *
    Number(quoteFormData?.ppt) *
    Number(getMultiplier(quoteFormData?.paymentFrequency || "N/A"));
  let gppInput = {
    pincode: calculatorFormData?.pincode ?? "",
    countrycode: calculatorFormData?.country_code ?? "",
    lifecovernew: quoteFormData?.lifeCover,
    dobspouse: "",
    nrimoblieno: parseInt(calculatorFormData?.mobileno) || "",
    adbterm: _.min([quoteFormData?.term, 80 - parseInt(calculatorFormData?.age)]) || 0,
    accidental_death_benefit: quoteFormData?.ADB_SA || 0,
    nriarrivingdate: convertToDateTime(calculatorFormData?.nri_india_arriving_date),
    premiumwithci: quoteFormData?.breakupDetail?.ciPremium
      ? quoteFormData?.breakupDetail?.base + quoteFormData?.breakupDetail?.ciPremium
      : "",
    annual_income: calculatorFormData?.yr_income,
    citerm:
      getCiTerm(quoteFormData?.paymentOption, calculatorFormData?.age, quoteFormData?.ppt, quoteFormData?.term) || 0,
    timestamp: getCurrentTimeStamp(),
    channel: quoteFormData?.channel ?? "",
    session_uid: "",
    plantype: "",
    monthly_premium: quoteFormData?.paymentFrequency === OPTION_VALUES.PAYMENT_TENURE.MONTHLY,
    keyword: "",
    plan: "",
    adbr: suitabilityData?.adbr,
    next_year_premium: quoteFormData?.breakupDetail?.onSecondYearPremium || 0,
    yearly_premium: quoteFormData?.breakupDetail?.annualPremium || 0,
    selectedplan: "",
    pfp_pk_id: "",
    lifecover: quoteFormData?.lifeCover,
    outputobjhold_8: suitabilityData?.OutputObjHold_8,
    outputobjhold_4: suitabilityData?.OutputObjHold_4,
    matchtype: "",
    reverse: "",
    pri_medical_data: "",
    education: calculatorFormData?.calc_education,

    propdob: calculatorFormData?.propAge ?? "",
    critical_illness_benefit: quoteFormData?.CI_SA || 0,
    premiumpaymentoption: PaymentOptionName[quoteFormData?.paymentOption],
    internationalmobileno: "",
    relation: suitabilityData?.relation,
    propgender: calculatorFormData?.propGender,
    iswop: isWopSelected,
    trai: calculatorFormData?.trai_flag,

    mobileno: calculatorFormData?.mobileno,
    annualincome: parseInt(calculatorFormData?.yr_income),
    uid: UID,
    premium: quoteFormData?.invest,
    ppt: quoteFormData?.ppt,
    dob: convertToISODate(calculatorFormData?.user_dob),
    term: quoteFormData?.term,
    sumassured: quoteFormData?.lifecover,
    age: calculatorFormData?.age,
    occupation: calculatorFormData?.calc_occupation,
    productid: calculatorFormData?.productCode,
    investment_frequency: quoteFormData?.paymentFrequency,
    p_gender: calculatorFormData?.propGender,
    gauranteedbenefit: "",
    mode: suitabilityData?.mode,
    policyterm: quoteFormData?.term,
    purchasefor: calculatorFormData?.relaiton_appForm,
    funds: "",
    paymentfrequency: quoteFormData?.paymentFrequency,
    annuity_amount: quoteFormData?.selectedAnnuityOption?.result?.PremiumSummary?.AnnuityAmount || "",
    appno: appFormData?.appNO,
    maritalstatus: calculatorFormData?.maritalStatus,
    lead_type: currentPageStep != "appFormScreen" ? "Lead" : "Drop",
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    p_dob: calculatorFormData?.propAge,
    guranteed_returns: "",
    incomebenefit: "",
    gender: calculatorFormData?.gender,
    city: calculatorFormData?.city,
    isnri: calculatorFormData?.nri === OPTION_VALUES.NRI_YES ? "1" : "0",
    spouse_relation: quoteFormData?.joint_life_relation,
    payoutoptions: quoteFormData?.selectedAnnuityOption?.result?.PremiumSummary?.AnnuityOption, //"SINGLE LIFE WITH RETURN OF PREMIUM",
    spouse_name:
      calculatorFormData?.relation === OPTION_VALUES.BUYING_FOR.SPOUCE ? appFormData?.personalDetails?.full_name : "",
    spouse_gender: calculatorFormData?.relation === OPTION_VALUES.BUYING_FOR.SPOUCE ? calculatorFormData?.gender : "",
    spouse_dob: calculatorFormData?.relation === OPTION_VALUES.BUYING_FOR.SPOUCE ? calculatorFormData?.user_dob : "",
    spouse_age: calculatorFormData?.relation === OPTION_VALUES.BUYING_FOR.SPOUCE ? calculatorFormData?.age : "",

    nps_flag: "No",
    lms_nri: calculatorFormData?.nri,
    brochure_selected: "",
    suitcheckbox: suitabilityData?.skip_suitability_check,
    specialdate: quoteFormData?.specialdateValue,
    p_age: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    emailid: calculatorFormData?.emailid,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    pensionfor: OPTION_VALUES.GPP_NETCORE_PENSION_FOR[quoteFormData?.annuityOption],
    trai_flag: yesNo(calculatorFormData?.trai_flag),
    tollfree_selected: "",
    qdata: queryParams?.get("qdata") ?? "",
    step: "",
    income_date: "",
    usetobacco: "",
    rop_value:death_benefit,

    paymentoption: "",
    parent_age: "",
    parent_dob: "",
    pgender: "",
    health: "",
    payoutdetails: "",
    proposerdetails: "",
    sourceurl: "",
    qdata_pasa: "",
    stay_details: "",
    proposer_stay_details: "",
    transactionid: appFormData?.transactionId ?? "",
    status: "",
    ekycdetails: "",
    health_la: "",
    health_pa: "",
    ckycflag: appFormData?.CkycJson?.CKYCflag,
    ekyc_flag: appFormData?.Ekyc?.EKYC_flag,
    isandroid: new URL(window.location.href).searchParams.get("device") === "android",
    isios: new URL(window.location.href).searchParams.get("device") === "ios",
    deferment_period: quoteFormData?.annuity_after_term || "",
    // NOT IN GPP NET CORE , BUT NEEDED BEC OF COMMON IMPLEMENTATION
    currentpagestep: currentPageStep,
    isenglish: "TRUE",
  };

  return gppInput;
};

export default getGppFlexiNetCoreInput;
